import styled from 'vue-styled-components'
import { breakpointStyle } from '../../utils'

let propsTransition = {
  transition: Boolean
}

const StyledMenu = styled.div`
  flex: 1 1 100%;
  position: relative;
  z-index: 5;
  margin-right: -20px;
  max-height: 100%;
  overflow: auto;
  ${props => breakpointStyle(props.theme.media.mobileM, `
    margin-right: -30px;
  `)}
  
   ${props => breakpointStyle(props.theme.media.mobileM, `
     overflow: hidden;
  `)}
`

const StyledOverflow = styled.div`
  overflow: hidden;
`

const propsTransitionButton = {
  ...propsTransition,
  margin: Boolean
}

const StyledButton = styled('button', propsTransitionButton)`
  display: block;
  width: calc(100% - 20px);

  height: 48px;
  padding: 0 24px;

  border: 1px solid #dce0e6;
  background-color: #fff;
  color: #000000;
  font-weight: ${props => props.theme.fontWeight.bold};
  font-size: 0.875rem;
  cursor: pointer;
  transition: ${props => props.transition ? 'all .5s ease-out' : 'all .3s ease-out'};
  opacity: ${props => props.transition ? '1' : '0'};
  transform: ${props => props.transition ? 'translateY(0)' : 'translateY(-100px)'};
  margin-top: ${props => props.margin && '24px'};

  &:hover {
    background-color: ${props => props.theme.colors.primary};
    border-color: ${props => props.theme.colors.primary};
    color: #fff;
  }
  
  ${props => breakpointStyle(props.theme.media.mobileM, `
    width: calc(100% - 30px);
  `)}
  
   ${props => breakpointStyle(props.theme.media.desktop, `
     display: none;
   `)}
`

const StyledLink = styled.a`
  display: inline-block;
  color: #222222;
  font-size: 1rem;
  text-decoration: none;
  
  &:hover {
    color: ${props => props.theme.colors.primary}
  }
`

const StyledSocialList = styled.ul`
  display: flex;
  margin: 67px 16px 27px;
  list-style: none;
  
  ${props => breakpointStyle(props.theme.media.desktop, `
     display: none;
  `)}
`

const StyledSocialItem = styled.li`
  overflow: hidden;
  
  :not(:last-child) {
    margin-right: 48px;
  }
`

const StyledLinkEmail = styled(StyledLink, propsTransition)`
  padding-left: 16px;
  transition: ${props => props.transition ? 'all .5s ease-out' : 'all .3s ease-out'};
  opacity: ${props => props.transition ? '1' : '0'};
  transform: ${props => props.transition ? 'translateY(0)' : 'translateY(-100px)'};
  
   ${props => breakpointStyle(props.theme.media.tablet, `
     display: none;
  `)}
`

export {
  StyledMenu,
  StyledButton,
  StyledSocialList,
  StyledSocialItem,
  StyledLink,
  StyledLinkEmail,
  StyledOverflow
}



// WEBPACK FOOTER //
// ./src/components/Menu/StyledMenu.js